import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { NavItem } from '@/types';

export function useNav() {
    return useQuery({
        queryKey: ['nav'],
        queryFn: async () => {
            const { data } = await api.get<{ data: NavItem[] }>('/nav');
            return data.data;
        },
        staleTime: 5 * 60 * 1000,
    });
}
